import { render } from "./PrefixModal.vue?vue&type=template&id=0109493b"
import script from "./PrefixModal.vue?vue&type=script&lang=js"
export * from "./PrefixModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__